<template>
  <div class="resource-group" :style="{ 'background-color': color, border: `5px solid ${color}` }">
    <div class="grid">
      <v-tooltip class="alert" right color="error">
        <template v-slot:activator="{ on, attrs }">
          <div class="alertBackground" ref="overloadTest"></div>
           <v-icon elevation="0" id="overloadIcon" ref="overload" v-bind="attrs" v-on="on">mdi-shield-alert</v-icon> <!--mdi-shield-alert -->
        </template>
        <span>Group is overloaded</span>
      </v-tooltip>

      <v-tooltip open-delay="750" class="alert" right :color="color">
        <template v-slot:activator="{ on, attrs }">
          <div>
            <div class="resource" ref="resource1BG">
              <!-- Needed for the circular animation-->
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div class="photoblock-parent">
                <img v-bind="attrs" v-on="on" ref="resource1" :src="require(`@/assets/avatars/userpics/` + name.toLowerCase() + `1.png`)" alt="" @mousedown="startDrag($event)" class="avatar photoblock" />
              </div>
            </div>
          </div>
        </template>
        <span>A resource which you can assign to a task by dragging</span>
      </v-tooltip>

      <div class="colorNames">
        <v-tooltip open-delay="750" class="alert" right :color="color">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="colorname">{{ name }}</div>
          </template>
          <span>The default type of tasks this group can work on</span>
        </v-tooltip>
        <v-tooltip open-delay="750" class="alert" right :color="color">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="colorname border unavailable" ref="alternate" :style="{ 'background-color': alternatecolor }">
              {{ alternatename }}
            </div>
          </template>
          <span>The alternate type of tasks this group can work on when finished training</span>
        </v-tooltip>
      </div>

      <v-tooltip open-delay="750" class="alert" right :color="color">
        <template v-slot:activator="{ on, attrs }">
          <div>
            <div class="resource" ref="resource2BG">
              <!-- Needed for the circular animation-->
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div class="photoblock-parent">
                <img v-bind="attrs" v-on="on" ref="resource2" :src="require(`@/assets/avatars/userpics/` + name.toLowerCase() + `2.png`)" alt="" @mousedown="startDrag($event)" class="avatar photoblock" />
              </div>
            </div>
          </div>
        </template>
        <span>A resource which you can assign to a task by dragging</span>
      </v-tooltip>

      <v-tooltip open-delay="750" class="alert" right :color="color">
        <template v-slot:activator="{ on, attrs }">
          <div>
            <div class="resource" ref="resource3BG">
              <!-- Needed for the circular animation-->
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div class="photoblock-parent">
                <img v-bind="attrs" v-on="on" ref="resource3" :src="require(`@/assets/avatars/userpics/` + name.toLowerCase() + `3.png`)" alt="" @mousedown="startDrag($event)" class="avatar photoblock" />
              </div>
            </div>
          </div>
        </template>
        <span>A resource which you can assign to a task by dragging</span>
      </v-tooltip>

      <div class="buttonContainer" >
        <div v-if="showButtons" class="bottom-buttons" :style="{ 'background-color': color }">
          <v-tooltip open-delay="750" class="alert" bottom :color="color">
            <template v-slot:activator="{ on, attrs }">
              <button class="alter-button" v-bind="attrs" v-on="on" @click="pressedPlus()">+</button>
            </template>
            <span>Hire a new resource</span>
          </v-tooltip>

          <v-tooltip open-delay="750" class="alert" bottom :color="color">
            <template v-slot:activator="{ on, attrs }">
          <button class="alter-button"  v-bind="attrs" v-on="on" @click="pressedMinus()">-</button>
            </template>
            <span>Fire a resource</span>
          </v-tooltip>

          <v-tooltip open-delay="750" class="alert" bottom :color="color">
            <template v-slot:activator="{ on, attrs }">
          <button class="alter-button" v-bind="attrs" v-on="on" @click="pressedTrain()">T</button>
            </template>
            <span>Train for another group</span>
          </v-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: { type: String, required: true },
    name: { type: String, required: true },
    resourceID: { type: String, required: true },
  },
  data: () => ({
    alternatename: "",
    alternatecolor: "",
    showButtons: true
  }),
  mounted: function () {
    //Add the event in order to detect the dragging of resources to assign to a task
    document.addEventListener("mousemove", this.dragMove);

    //For updates
    this.$store.state.ResourceComponents[this.name] = this;
  },
  methods: {
    updateButtons(){
      this.showButtons = this.$store.state.simulator.params.allowResourceChange
    },
    //Get the overload divs
    getOverloadDivs() {
      return [this.$refs.overloadTest, this.$refs.overload];
    },
    //Get all the photoblocks
    getPhotoBlockRefs() {
      return [this.$refs.resource1, this.$refs.resource2, this.$refs.resource3];
    },
    //Get all the photoblocksRefs
    getPhotoBackgroundRefs() {
      return [this.$refs.resource1BG, this.$refs.resource2BG, this.$refs.resource3BG];
    },
    checkIfPaused() {
      if (!this.$store.state.manuallyPaused) {
        this.$toast.error("You have to pause before making adjustments", { position: "bottom-right", timeout: 7500 });
        return false;
      }

      return true;
    },
    pressedPlus() {
      if (!this.checkIfPaused()) {
        return;
      }

      //Attempt to add a resource
      var currResourceGroup = this.$store.state.simulator.resourcePool.getResourceGroupFromName(this.name);
      const result = currResourceGroup.hireResource();

      if (result == "noHire") {
        this.$toast.error("You cannot have more than 3 resource per group", { position: "bottom-right", timeout: 7500 });
      }

      if (result == "cancelledFire") {
        this.$toast.success("Cancelled the firing process of a resource", { position: "bottom-right", timeout: 7500 });
      }

      if (result == "startedHire") {
        this.$toast.success("Started hiring a resource, this will take " + this.$store.state.simulator.params.hireTime + " hours.\nTo cancel, press the fire button", { position: "bottom-right", timeout: 7500 });
      }
      this.$store.state.visualiser.updateElements();
    },
    pressedMinus() {
      if (!this.checkIfPaused()) {
        return;
      }

      //Attempt to add a resource
      var currResourceGroup = this.$store.state.simulator.resourcePool.getResourceGroupFromName(this.name);
      const result = currResourceGroup.fireResource();

      if (result == "noFire") {
        this.$toast.error("You cannot have less than 1 resource per group", { position: "bottom-right", timeout: 7500 });
      }

      if (result == "cancelledHire") {
        this.$toast.success("Cancelled the hiring process of a resource", { position: "bottom-right", timeout: 7500 });
      }

      if (result == "startedFire") {
        this.$toast.success("Started to fire a resource, this will take " + this.$store.state.simulator.params.fireTime + " hours.\nTo cancel this, press the hire button", { position: "bottom-right", timeout: 7500 });
      }

      this.$store.state.visualiser.updateElements();
    },
    pressedTrain() {
      if (!this.checkIfPaused()) {
        return;
      }

      const self = this;

      var resourcePool = this.$store.state.simulator.resourcePool;

      //Filter the names so that you cant train your own resource group, or the group you already trained for
      var resourceGroups = resourcePool.resourceGroups;
      var currResourceGroup = resourcePool.getResourceGroupFromName(self.name);
      var availableResourceNames = [];

      resourceGroups.forEach((otherGroup) => {
        if (otherGroup.name != currResourceGroup.name && otherGroup.name != currResourceGroup.alternateName && otherGroup.name != currResourceGroup.alternateNameToBeTrained) {
          availableResourceNames.push(otherGroup.name);
        }
      });
      var params = self.$store.state.simulator.params;

      this.$swal({
        title: "Train alternate resource",
        text: `Select another resource type. This will take ${params.trainTime} hours, and will cost ${params.trainCost.toLocaleString()}$.`,
        footer: "Note that you can only train for one other group",
        input: "select",
        inputOptions: availableResourceNames,
        showCancelButton: true,
        animation: "slide-from-top",
      }).then(function (inputValue) {
        if (inputValue && inputValue.isConfirmed) {
          //Get the alternate resource name
          var alternateMethod = availableResourceNames[inputValue.value];
          resourcePool.getResourceGroupFromName(self.name).trainResource(alternateMethod);
          self.$store.state.visualiser.updateElements();
        }
      });
    },

    startDrag(event) {
      //Get the index of the photoblock
      var index = this.getPhotoBlockRefs().indexOf(event.srcElement);

      //Store the current resource in order to be used in the CustomGantt component
      var currResource = this.$store.state.simulator.resourcePool.getResourceGroupFromName(this.name).resources[index];
      this.$store.state.visualiser.assignHandler.startDrag(event, currResource, this);
      this.$forceUpdate();
    },
    dragMove(event) {
      this.$store.state.visualiser.assignHandler.dragMove(event);
    },
  },
};
</script>

<style scoped>
.resource {
  display: block;
  width: var(--worker-size);
  height: var(--worker-size);
  border-radius: 5px;
  /* background-color: black; */
  /* transform: translate(-4px, -4px); */
}

.lds-ring-add {
  pointer-events: none;
}
.lds-ring-add div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: calc(var(--worker-size) + 8px);
  height: calc(var(--worker-size) + 8px);
  margin: -4px;
  border: 4px solid #fff;
  border-radius: 50%;
  animation: lds-ring-add 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring-add div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring-add div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring-add div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring-add {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.lds-ring-rem {
}
.lds-ring-rem div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: calc(var(--worker-size) + 8px);
  height: calc(var(--worker-size) + 8px);
  margin: -4px;
  border: 4px solid rgb(0, 0, 0);
  border-radius: 50%;
  animation: lds-ring-rem 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: black transparent transparent transparent;
}
.lds-ring-rem div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring-rem div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring-rem div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring-rem {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

.photoblock-parent{
  position: relative;
  width: var(--worker-size);
  height: var(--worker-size);


}

.resource-group {
  height: 100%;
  user-select: none;
  padding: 0px;
  border-radius: 10px;
}

.alter-button {
  width: 100%;
  height: 90%;
  font-size: 0.8em;
  border-radius: 5px;

}

.grid {
  width: 100%;
  height: 100%;
  display: grid;
  position: relative;
  grid-template-columns: 50% 50%;
  grid-template-rows: 41% 41% 18%;
  grid-gap: 0em;
  padding: 0px;
  margin: 0;
  z-index: 10;
  justify-content: center;
  align-content: center;
  place-items: center;
}

.unavailable {
  display: none;
}

.avatar {
  width: 100%;
  height: 100%;
  transition: background-color 0.15s;
}

.photoblock {
  height: var(--worker-size);
  width: var(--worker-size);
  background-color: #bbb;
  border-radius: 50%;
  /* position: relative; */
  transition: background-color 0.15s;
  margin: 0;
}

.assignedToTask {
  opacity: 0.4;
  transition: opacity 0.2s;
}

.invalid{
  cursor: none;
}

.valid {
  filter: brightness(1);
  -webkit-transition : -webkit-filter 200ms linear

}
.invalid {
  filter: brightness(0.5);
  -webkit-transition : -webkit-filter 200ms linear

}

.colorname {
  padding-top: 0.15em;
  font-size: 1em;
  text-align: center;
  margin: 0;
  font-weight: bold;
  width: 100%;
}

.colorNames {
  padding-top: 0px;
  width: 100%;
  display: block;
  position: relative;
  top:-2px;
}

.buttonContainer {
  z-index: 0;
  grid-column: 1/3;
  width: 100%;
  height: 100%;
  display: flex;
}

.bottom-buttons {
  font-size: 1.4em;
  display: grid;
  grid-template-columns: 33% 33% 33%;
  align-self: flex-end;
  width: 100%;
  height: 22px;
  padding-left: 8px;
  padding-right: 8px;
  color: white;
}

button {
  height: 28px;
}
.border {
  animation-name: example;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}
@keyframes example {
  0% {
    filter: opacity(1);
    /* filter: contrast(1); */
    -webkit-filter: opacity(1);
    /* -webkit-filter: contrast(1); */
  }
  50% {
    filter: opacity(0.1);
    /* filter: contrast(0.4); */
    -webkit-filter: opacity(0.1);
    /* -webkit-filter: contrast(0.4); */
  }
  100% {
    filter: opacity(1);
    /* filter: contrast(1); */
    -webkit-filter: opacity(1);
    /* -webkit-filter: contrast(1); */
  }
}
i.v-icon.v-icon {
  position: absolute;
  bottom: 18px;
  color: red;
  z-index: 75000;
}

.alertBackground {
  position: absolute;
  width: 10px;
  height: 15px;
  bottom: 23px;
  background-color: white;
  z-index: 5000;
}
</style>
